import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {ChronoCode} from '../message/ChronoCode';
import {ChronoCodeScenario} from './ChronoCodeScenario';
import {ChronocodeCriteria} from './ChronocodeCriteria';

export class ChronoCodeWrapper extends BaseWrapper<ChronoCode, ChronocodeCriteria, ChronoCodeScenario>  {}

